<template>
  <div>
    <div class="row">
      <div class="col-xl-12">
        <div class="card card-custom gutter-b card-stretch">
          <div class="card-body pt-5 pb-0 mt-n3">
            <div class="row mb-10 mt-5">
              <div class="col-md-4">
                <label class="font-size-h6 font-weight-bolder text-dark"
                  >Serial</label
                >
                <b-form-input
                  class="form-control"
                  v-model="form.serial"
                  aria-describedby="input-1-live-feedback"
                ></b-form-input>
              </div>
              <div class="col-md-4">
                <button
                  type="button"
                  v-on:click="filtrar"
                  ref="submit_filtro"
                  class="btn btn-primary mt-9"
                >
                  Fitlrar
                </button>
              </div>
            </div>
            <div class="table" v-if="historico.length">
              <table class="table table-borderless table-vertical-center">
                <thead>
                  <tr>
                    <th class="p-0">Plugin</th>
                    <th class="p-0">Marcado em</th>
                    <th class="p-0">Desmarcado em</th>
                    <th class="p-0">Marcado automático</th>
                    <th class="p-0 min-w-50px"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(valor, index) in historico" :key="'valor' + index">
                    <td class="pl-0">
                      <span v-html="produtos(valor.produto)" class="text-muted font-weight-bold d-block"></span>
                    </td>
                    <td class="pl-0">
                      <span class="text-muted font-weight-bold d-block">{{ formatDate(valor.created_at, 'DD/MM/YYYY HH:mm:ss') }}</span>
                    </td>
                    <td class="pl-0">
                      <span class="text-muted font-weight-bold d-block">{{ valor.deleted_at != null ? formatDate(valor.deleted_at, 'DD/MM/YYYY HH:mm:ss') : '' }}</span>
                    </td>
                    <td class="pl-0">
                      <span class="text-muted font-weight-bold d-block">
                        <Check v-if="valor.automatico" :size="16" />
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { mask } from "vue-the-mask";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import ApplicationMixin from "@/modules/Application/mixins/SistemaMixin";
import Check from "vue-material-design-icons/Check.vue";

export default {
  name: "app-config-renovacoes-plugins",
  mixins: [ApplicationMixin],
  components: {
    Check,
  },
  directives: {
    mask,
  },
  data() {
    return {
      historico: [],
      form: {},
    };
  },
  methods: {
    async filtrar() {
      const submitButton = this.$refs["submit_filtro"];

      try {
        if (!this.form.serial || this.form.serial == '') {
          return this.$toast.error("Informe o Serial!");
        }

        submitButton.classList.add("spinner", "spinner-light", "spinner-right");

        const { data } = await this.$http.post("/renovacoes/historico/plugins", {
          serial: this.form.serial
        });
  
        this.historico = data;

        if (!this.historico || this.historico == '') {
          this.$toast.error("Nenhum histórico de Plugin!");
          submitButton.classList.remove(
            "spinner",
            "spinner-light",
            "spinner-right"
          );
        }

        submitButton.classList.remove(
          "spinner",
          "spinner-light",
          "spinner-right"
        );

      } catch {
        submitButton.classList.remove(
          "spinner",
          "spinner-light",
          "spinner-right"
        );
        return [];
      }
    },

    produtos(produto) { 
      console.log(produto);
      if (produto == "A") {
        return 'Aplicativos Comerciais';
      }
      if (produto == "B") {
        return 'Ordem de Serviço';
      }
      if (produto == "C") {
        return 'ClippPro';
      }
      if (produto == "D") {
        return 'Cheff';
      }
      if (produto == "E") {
        return 'Service';
      }
      if (produto == "F") {
        return 'SMS';
      }
      if (produto == "G") {
        return 'Maquininha';
      }
      if (produto == "H") {
        return 'ClippFacil';
      }
      if (produto == "I") {
        return 'Clipp360';
      }
      if (produto == "J") {
        return 'Clipp360OS';
      }
      if (produto == "K") {
        return 'ClippMei';
      }
      if (produto == "L") {
        return 'Licença Adicional';
      }
      if (produto == "M") {
        return 'Service MEI';
      }
      if (produto == "N") {
        return 'ECommerce';
      }
      if (produto == "P") {
        return 'Força de Vendas';
      }
      if (produto == "Q") {
        return 'Backup Cloud';
      }
      if (produto == "R") {
        return 'Shipay';
      }
      if (produto == "T") {
        return 'IMendes';
      }
      if (produto == "U") {
        return 'Cheff MEI';
      }
      if (produto == "V") {
        return 'ClippMei - CPF';
      }
      if (produto == "X") {
        return 'ChatC4';
      }
      return "";
    },
  },
  computed: {
    ...mapGetters(["layoutConfig"]),
    config() {
      return this.layoutConfig();
    },
  },
  mounted() {
    this.produtos();
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: "Histórico de Plugins",
      },
    ]);
  },
};
</script>
